import {
  Box,
  Button,
  ButtonAppearance,
  ButtonComponentProps,
  ButtonSize,
  Modal,
  ModalHeader,
  ModalSize,
} from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const HeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  flexDirection: { sm: 'row' },
  gap: { sm: '500' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
  `}
  height: 70px;
`;

interface ButtonProps {
  secondary?: boolean;
}

export const BodyStyled = styled(Box).attrs({
  m: { sm: '500' },
  flexDirection: { sm: 'row' },
  flexGrow: { sm: '1' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.white};
  `}
`;

export const ButtonStyled = styled(Button).attrs<ButtonProps>((props) => ({
  appearance: props.secondary ? ButtonAppearance.SECONDARY : ButtonAppearance.PRIMARY,
  size: ButtonSize.SMALL,
}))<ButtonComponentProps & ButtonProps>`
  ${({ theme, secondary }) => css`
    width: 100px;
    height: 36px;
    margin-left: ${!secondary && theme.spacings[400]};
    padding: 0 ${theme.spacings[500]};
    justify-content: space-evenly;
  `}
`;

export const SeparatorStyled = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.blue[800]};
    opacity: 20%;
    width: 2px;
  `}
`;

export const ModalFooterStyled = styled(Box).attrs({
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
`;

export const ModalStyled = styled(Modal).attrs({
  size: ModalSize.DEFAULT,
})`
  width: 40%;
  max-width: 40%;
  height: 280px;
  max-height: 50%;
`;
export const ModalHeaderStyled = styled(ModalHeader)`
  display: flex;
  align-items: center;
  margin: 0;
  ${({ theme }) => css`
    padding: ${theme.spacings[400]};
    height: ${theme.spacings[800]};
  `}
`;
